import { ThemeProvider as EmotionThemeProvider, Global } from '@emotion/react';

import atlasTokens from '../theme/tokens/theme/atlas.json';
import lightTokens from '../theme/tokens/theme/light.json';
import { GlobalStyles } from './GlobalStyles';
import { grid } from './grid';
import { theme } from './theme';
// import darkTokens from '../theme/tokens/theme/dark.json';

type ThemeProviderProps = {
  children: JSX.Element | JSX.Element[];
  type: 'dark' | 'light' | 'atlas';
};

export function ThemeProvider({
  children,
  type = 'light',
}: ThemeProviderProps) {
  const tokens =
    type === 'light'
      ? lightTokens
      : type === 'atlas'
      ? atlasTokens
      : lightTokens; //TODO: darkTokens
  const mixedTheme = { ...theme, grid, tokens };

  return (
    <EmotionThemeProvider theme={mixedTheme}>
      <Global styles={GlobalStyles} />
      {children}
    </EmotionThemeProvider>
  );
}
